export const Color = Object.freeze({
	base: '#17a3ea',
	transparent: 'transparent',
	white: '#fff',
	gray40: '#bdc1c6',
	gray90: '#525c69',
	collab70: '#00a94e',
	collab60: '#19cc45',
	collab50: '#6be860',
	collab10: '#f2fee2',
	orange50: '#ffa900',
	orangeExtra: '#e88c02',
	accentBlue: '#00ace3',
	accentExtraAqua: '#37C5D8',
	accentMainPrimaryAlt: '#1f86ff',
	accentSoftBorderBlue: '#88c8f8',
	accentMainSuccess: '#1bce7b',
	accentMainSuccessAlt: '#00a659',
	base4: '#a8adb4',
	blue60: '#11a9d9',
});

export const ColorToken = Object.freeze({
	base: 'base',
	primary: 'primary',
	secondary: 'secondary',
	alert: 'alert',
	aiAssistant: 'ai-assistant',
});
